<div class="flex">
  <div class="flex-col basis-full capability-details p-20">
    <div class="fixed-header">
      <div class="flex flex-row header justify-between mb-12">
        <span class="fw-600 fs-24 justify-center items-center">{{value?.certificateName ? value?.certificateName : '--'}}</span>
        <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
      </div>
      <mat-divider class="neutral-2"></mat-divider>
      <div class="flex flex-row header justify-between">
        <div>
          <div class="flex flex-row flex-wrap gap-30">
              <div class="pt-16 pb-16 flex flex-row justify-start items-center">
                  <div class="mat-body-2 fs-16 fw-600 left-key-width">{{'TENANT_DETAILS.KEY_VAULT_URL' | transloco}}</div>
                  <span>:</span><span class="ml-12">{{value?.keyvaultUrl ? value?.keyvaultUrl : '--'}}</span>
              </div>
          </div>
          <div class="flex flex-row flex-wrap gap-30">
              <div class="pt-16 pb-16 flex flex-row justify-start items-center">
                  <div class="mat-body-2 fs-16 fw-600 left-key-width">{{'TENANT_DETAILS.KEY_VAULT_NAME' | transloco}}</div>
                  <span>:</span><span class="ml-12">{{value?.keyvaultName ? value?.keyvaultName : '--'}}</span>
              </div>
          </div>
          <div class="flex flex-row flex-wrap gap-30">
            <div class="pt-16 pb-16 flex flex-row justify-start items-center">
                <div class="mat-body-2 fs-16 fw-600 left-key-width">{{'TENANT_DETAILS.DOMAIN' | transloco}}</div>
                <span>:</span><span class="ml-12">{{value?.domain ? value?.domain : '--'}}</span>
            </div>
          </div>
          <div class="flex flex-row flex-wrap gap-30">
            <div class="pt-16 pb-16 flex flex-row justify-start items-center">
              <div class="mat-body-2 fs-16 fw-600 left-key-width">{{'TENANT_DETAILS.KEY_RESOURCE_GROUP' | transloco}}</div>
              <span>:</span><span class="ml-12">{{value?.keyvaultResourceGroup ? value?.keyvaultResourceGroup : '--'}}</span>
            </div>
          </div>
          <div class="flex flex-row flex-wrap gap-30">
            <div class="pt-16 pb-16 flex flex-row justify-start items-center">
              <div class="mat-body-2 fs-16 fw-600 left-key-width">{{'TENANT_DETAILS.NAME' | transloco}}</div>
              <span>:</span><span class="ml-12">{{value?.certificateName ? value?.certificateName : '--'}}</span>
            </div>
          </div>
          <div class="flex flex-row flex-wrap gap-30">
            <div class="pt-16 pb-16 flex flex-row justify-start items-center">
              <div class="mat-body-2 fs-16 fw-600 left-key-width">{{'TENANT_DETAILS.CERT_ID' | transloco}}</div>
              <span>:</span><span class="ml-12">{{value?.certificateSubscriptionId ? value?.certificateSubscriptionId : '--'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
